module.exports = __webpack_public_path__ + "img/approval.a15ad22f.svg";